import { render } from "./EventsFilter.vue?vue&type=template&id=997e5b4e&scoped=true"
import script from "./EventsFilter.vue?vue&type=script&lang=js"
export * from "./EventsFilter.vue?vue&type=script&lang=js"

import "./EventsFilter.vue?vue&type=style&index=0&id=997e5b4e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-997e5b4e"]])

export default __exports__